import { useQuery } from "react-query";
import { getOfficeVendorServiceByOfficeId } from "../../../../actions/CarrierAgreementMgmt/OfficeVendorService";

export const useGetOfficeVendorServiceByOfficeId = (officeId) => {
  return useQuery(
    ["GetOfficeVendorServiceByOfficeId", officeId],
    () => getOfficeVendorServiceByOfficeId(officeId),
    { refetchOnWindowFocus: false }
  );
};
